import { Controller } from "@hotwired/stimulus";

export default class extends Controller {

  connect() {
    // console.log("OtherAthAffLinkController connected!");
  }

  toggleStatus(event) {
    event.preventDefault();

    const link = event.currentTarget;
    const linkId = event.currentTarget.dataset.id;
    const url = event.currentTarget.dataset.url;

    fetch(url, {
      method: "PATCH",
      headers: {
        "Content-Type": "application/json",
        "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]').content
      }
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.success) {
          const linkText = document.getElementById(`athlete-affiliate-link-${linkId}`);

          const textSpan = link.querySelector("span");


          if (linkText) {

            if (data.status === "archived") {
              linkText.classList.add('red-text');
              textSpan.textContent = "Activate";
              textSpan.classList.remove("red-text");
              textSpan.classList.add("green-text");
            }

            if (data.status === "active") {
              linkText.classList.remove('red-text');
              textSpan.textContent = "Archive";
              textSpan.classList.remove("green-text");
              textSpan.classList.add("red-text");
            }
          }
        }
      })
      .catch((error) => {
        console.error("Error toggling status:", error);
      });
  }


  // toggleStatus(event) {
  //   event.preventDefault();

  //   const linkId = event.currentTarget.dataset.id;
  //   const url = event.currentTarget.dataset.url;

  //   fetch(url, {
  //     method: "PATCH",
  //     headers: {
  //       "Content-Type": "application/json",
  //       "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]').content
  //     }
  //   })
  //     .then((response) => response.json())
  //     .then((data) => {
  //       //if (data.success && data.status === "archived") {
  //       if (data.success) {
  //         // Hide the row if status is archived
  //         const row = document.getElementById(`athlete-affiliate-link-${linkId}`);
  //         if (row) {
  //           row.remove();
  //         }
  //       }
  //     })
  //     .catch((error) => {
  //       console.error("Error toggling status:", error);
  //     });
  // }
}
